import { isNumber as _isNumber } from "lodash";

/**
 * Helper class for cac form validation
 */
export default class Validate {

  static async handleFormFieldValue(component, field, value) {
    try {
      const validationResults = await component.validatorHelper.isFieldValid(
        field.name,
        value
      );

      const validationErrors = component.formHelper.getValidationErrorMessage(
        validationResults
      );

      component.formHelper.setValidationResultsInStore(field, validationErrors);
      component.formHelper.setFormFieldValueInStore(field, value);

      // remove error message if all fields are now valid
      if (component.isFormValid) {
        component.setFormError(null);
      }

      // We want to pre-fetch stakeholders if we get an address and/or zip
      if (component.formHelper.addressHasChanged(field, validationResults)) {
        component.prefetchStakeholders();
      }
    } catch (err) {
      component.formHelper.setFormFieldValueInStore(field, value);
    }
  }

  static normalizePhone(phone) {
    if (!phone) {
      return '';
    }

    const digitParts = phone.match(/\d+/g);
    return digitParts ? digitParts.join('') : '';
  }

  static normalizeAdvocatePhone(payload) {
    //if we dont change the phone on the register to vote page, it gets the phone from the store where it is already
    //normalized and an integer. So no need to normalize it again.
    if(_isNumber(payload.identifiers.phone)) {
      return payload;
    }

    payload.identifiers.phone = parseInt(
      Validate.normalizePhone(payload.identifiers.phone),
      10
    );
    return payload;
  }
}